/* eslint-disable no-restricted-syntax */
function stringifyQuery(obj) {
  const res = obj
    ? Object.keys(obj)
        .map((key) => {
          const value = obj[key];

          if (value === undefined) {
            return '';
          }

          if (value === null) {
            return encodeURIComponent(key);
          }

          if (Array.isArray(value)) {
            const result = [];
            value.forEach((el) => {
              if (el === undefined) {
                return;
              }
              if (el === null) {
                result.push(encodeURIComponent(key));
              } else {
                result.push(`${encodeURIComponent(key)}=${encodeURIComponent(el)}`);
              }
            });
            return result.join('&');
          }

          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .filter((x) => x.length > 0)
        .join('&')
    : null;
  return res ? `?${res}` : '';
}

function unserializeQuery(url) {
  const searchParams = url.split('?')[1];
  const result = {};
  if (searchParams !== undefined) {
    const paramParts = searchParams.split('&');
    for (const part of paramParts) {
      const paramValuePair = part.split('=');
      if (paramValuePair.length === 2) {
        result[paramValuePair[0]] = decodeURIComponent(paramValuePair[1]);
      }
    }
  }
  return result;
}

export default {
  stringifyQuery,
  unserializeQuery,
};
